import React from 'react';
import * as Sentry from '@sentry/react';
import classnames from 'classnames';
import { Content } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import PairHome from './PairHome';
import S from './PairingFlow.css';
import PairForm from './PairForm';
import PairResult from './PairResult';
import Loading from '../../components/Loading';
import UnpairForm from './UnpairForm';
import UnpairSaleForm from './UnpairSaleForm';
import UnpairOtherForm from './UnpairOtherForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class PairingFlow extends React.Component {
  constructor(props) {
    super(props);
    const {
      asset,
      assetDeviceId,
      assetId,
      tracker,
      trackerId,
      trackerDeviceId,
      trackerInstallLocation
    } = props;
    let tabId = null;
    if (trackerId && assetId) {
      tabId = 'unpair';
    } else if (assetId) {
      tabId = 'pair';
    }
    const username = GlobalState.get().auth.profile.name || GlobalState.get().auth.profile.username;
    this.state = {
      tabId,
      asset: asset || null,
      assetId: assetId || null,
      assetDeviceId: assetDeviceId || null,
      tracker: tracker || null,
      trackerId: trackerId || null,
      trackerDeviceId: trackerDeviceId || null,
      trackerInstallLocation: trackerInstallLocation || null,
      sale: null,
      saleDeviceId: null,
      unpairReason: null,
      loading: false,
      // UnpairSaleForm
      customerName: null,
      salesperson: username,
      createdBy: username,
      // UnpairOtherForm
      notes: null
    };
  }
  componentDidMount() {
    const {
      trackerDeviceId,
      isPendingRemove
    } = this.props;
    if (trackerDeviceId) {
      this.loadTrackerData();
    }
    if (isPendingRemove) {
      this.loadSaleData();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      tabId,
      trackerId
    } = this.state;
    if (tabId === 'unpair' && trackerId !== prevState.trackerId) {
      // DeviceSearch will get the list of trackers by dispatching an api-redux action.
      // Unfortunately, DeviceSearch only surfaces the trackerId, which doesn't allow us
      // to use redux lookup table.
      this.loadTrackerAndAssetData();
    }
  }
  async loadTrackerAndAssetData() {
    const {
      actions,
      parentNetworkId,
      networkId
    } = this.props;
    const {
      trackerId
    } = this.state;
    this.setState({
      loading: true
    });
    const vehicleNetworkAlias = Config.get('VehicleNetwork.dealer', 'aliasKey', 'deviceId');
    const trackerNetworkAlias = Config.get('LocatorNetwork', 'aliasKey');
    try {
      let trackerDevice;
      if (trackerId) {
        trackerDevice = (await GlobalState.dispatch(actions.parent().child('locators').search({
          limit: 100,
          filter: {
            type: 'logical',
            operator: 'and',
            conditions: [{
              type: 'equals',
              field: `networkAliases/${networkId}/${trackerNetworkAlias}`,
              fieldType: 'string',
              value: [trackerId]
            }]
          }
        }, null, 'pairActionSearch')))?.items?.[0];
      }
      const trackerItem = trackerDevice;

      // It returns device header data + data data.
      const assetDevice = await GlobalState.dispatch(actions.parent().child('vehicles').item(trackerItem?.data?.vehicle?.id).get());
      this.setState({
        asset: assetDevice,
        assetId: assetDevice?.networkAliases?.[parentNetworkId]?.[vehicleNetworkAlias],
        assetDeviceId: assetDevice.id,
        tracker: trackerItem,
        trackerId: trackerItem?.networkAliases?.[networkId]?.[trackerNetworkAlias],
        trackerDeviceId: trackerItem.id,
        trackerInstallLocation: trackerItem?.data?.installLocation
      });
      if (assetDevice?.data?.pendingSaleId) {
        // It returns device header data + data data.
        const saleDevice = await GlobalState.dispatch(actions.parent().child('sales').item(assetDevice?.data?.pendingSaleId).get());
        this.setState({
          sale: saleDevice,
          saleDeviceId: saleDevice?.id,
          unpairReason: saleDevice?.data?.type,
          customerName: saleDevice?.data?.customer?.name,
          salesperson: saleDevice?.data?.salesperson,
          createdBy: saleDevice?.data?.createdBy
        });
      }
    } catch (err) {
      console.error(err);
      Sentry.captureException(err);
    }
    this.setState({
      loading: false
    });
  }
  async loadTrackerData() {
    const {
      actions,
      trackerDeviceId,
      networkId,
      trackerId,
      assetId,
      isPendingReplace
    } = this.props;
    const trackerNetworkAlias = Config.get('LocatorNetwork', 'aliasKey', 'serialNumber');
    let tabId = isPendingReplace ? 'pair' : 'unpair';
    if (!trackerId) {
      this.setState({
        loading: true
      });
      if (!isPendingReplace) {
        try {
          const device = await GlobalState.dispatch(actions.parent().child('locators').item(trackerDeviceId).get());
          tabId = assetId ? 'unpair' : 'pair';
          this.setState({
            tracker: device,
            trackerId: device?.networkAliases?.[networkId]?.[trackerNetworkAlias],
            trackerDeviceId: device.id,
            trackerInstallLocation: device?.data?.installLocation
          });
        } catch (err) {
          console.error(err);
          Sentry.captureException(err);
        }
      }
    }
    this.setState({
      loading: false,
      tabId
    });
  }
  async loadSaleData() {
    const {
      actions,
      asset
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const saleDevice = await GlobalState.dispatch(actions.parent().child('sales').item(asset?.data?.pendingSaleId).get());
      this.setState({
        sale: saleDevice,
        saleDeviceId: saleDevice?.id,
        customerName: saleDevice?.data?.customer?.name,
        salesperson: saleDevice?.data?.salesperson,
        createdBy: saleDevice?.data?.createdBy,
        unpairReason: saleDevice?.data?.type
      });
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
    }
    this.setState({
      loading: false
    });
  }
  onReset = (tabId, hard = true) => {
    const nState = {
      ...this.state
    };
    if (hard) {
      nState.tabId = tabId;
      nState.asset = null;
      nState.assetId = null;
      nState.tracker = null;
      nState.trackerId = null;
      nState.trackerDeviceId = null;
      nState.trackerInstallLocation = null;
      nState.sale = null;
      nState.saleDeviceId = null;
      nState.pairing = false;
      nState.selling = false;
    } else {
      nState.tabId = tabId;
      nState.trackerId = null;
    }
    this.setState(nState);
  };
  onChange = ({
    data,
    value
  }) => {
    this.setState({
      [data]: value
    });
  };
  onPair = async () => {
    const {
      onPair
    } = this.props;
    const {
      tabId,
      ...rest
    } = this.state;
    if (typeof onPair === 'function') {
      this.setState({
        loading: true
      });
      try {
        const {
          asset,
          tracker
        } = await onPair(rest);
        this.setState({
          tabId: 'success',
          asset,
          tracker,
          pairing: true
        });
      } catch (err) {
        this.setState({
          tabId: 'failure',
          asset: err.asset,
          tracker: err.tracker,
          error: err,
          pairing: true
        });
      }
      this.setState({
        loading: false
      });
    }
  };
  onUnpair = async () => {
    const {
      onUnpair,
      networkId
    } = this.props;
    const {
      tabId,
      ...rest
    } = this.state;
    if (typeof onUnpair === 'function') {
      this.setState({
        loading: true
      });
      const trackerNetworkAlias = Config.get('LocatorNetwork', 'aliasKey');
      try {
        const {
          tracker,
          saleId
        } = await onUnpair(rest);
        this.setState({
          tabId: 'success',
          tracker,
          trackerId: tracker?.networkAliases?.[networkId]?.[trackerNetworkAlias],
          trackerDeviceId: tracker.id,
          saleDeviceId: saleId,
          pairing: false,
          selling: tabId === 'unpair-and-sell'
        });
      } catch (err) {
        this.setState({
          tabId: 'failure',
          tracker: err.tracker,
          error: err,
          pairing: false,
          selling: tabId === 'unpair-and-sell'
        });
      }
      this.setState({
        loading: false
      });
    }
  };
  getScreenProps() {
    const {
      asset,
      assetId,
      tracker,
      trackerId,
      trackerInstallLocation,
      sale,
      saleDeviceId,
      customerName,
      salesperson,
      createdBy,
      notes,
      unpairReason,
      loading
    } = this.state;
    return {
      headerClassName: classnames(S.pad, S.header),
      areaClassName: classnames(S.contentArea, S.pad),
      footerClassName: classnames(S.pad),
      ...this.props,
      asset,
      assetId,
      tracker,
      trackerId,
      trackerInstallLocation,
      sale,
      saleDeviceId,
      customerName,
      salesperson,
      createdBy,
      notes,
      unpairReason,
      loading
    };
  }
  renderTab() {
    const {
      pairTitleIcon,
      unpairTitleIcon
    } = this.props;
    const {
      tabId,
      error,
      pairing,
      selling
    } = this.state;
    switch (tabId) {
      case 'pair':
        return /*#__PURE__*/_jsx(PairForm, {
          ...this.getScreenProps(),
          titleIcon: pairTitleIcon,
          onChange: this.onChange,
          onPair: this.onPair
        });
      case 'unpair':
        return /*#__PURE__*/_jsx(UnpairForm, {
          ...this.getScreenProps(),
          titleIcon: unpairTitleIcon,
          onChange: this.onChange,
          onUnpair: this.onUnpair
        });
      case 'unpair-and-sell':
        return /*#__PURE__*/_jsx(UnpairSaleForm, {
          ...this.getScreenProps(),
          titleIcon: unpairTitleIcon,
          onChange: this.onChange,
          onUnpair: this.onUnpair
        });
      case 'unpair-and-other':
        return /*#__PURE__*/_jsx(UnpairOtherForm, {
          ...this.getScreenProps(),
          titleIcon: unpairTitleIcon,
          onChange: this.onChange,
          onUnpair: this.onUnpair
        });
      case 'success':
        return /*#__PURE__*/_jsx(PairResult, {
          type: "success",
          pairing: pairing,
          selling: selling,
          onReset: this.onReset,
          ...this.getScreenProps(),
          titleIcon: pairing ? pairTitleIcon : unpairTitleIcon
        });
      case 'failure':
        return /*#__PURE__*/_jsx(PairResult, {
          type: "failure",
          pairing: pairing,
          onReset: this.onReset,
          error: error,
          ...this.getScreenProps(),
          titleIcon: pairing ? pairTitleIcon : unpairTitleIcon
        });
      default:
        return /*#__PURE__*/_jsx(PairHome, {
          ...this.getScreenProps(),
          titleIcon: pairTitleIcon,
          setTabId: this.setTabId
        });
    }
  }
  setTabId = ({
    data
  }) => {
    this.setState({
      tabId: data
    });
  };
  getLoadingMessage(tabId) {
    const {
      trackerDeviceId
    } = this.props;
    if (trackerDeviceId) {
      return 'Loading...';
    }
    if (tabId === 'pair') {
      return 'Pairing...';
    }
    if (tabId === 'unpair') {
      return 'Unpairing...';
    }
    return 'Loading...';
  }
  render() {
    const {
      mobile
    } = this.props;
    const {
      loading,
      tabId
    } = this.state;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Content, {
        variant: "pairContent",
        relative: !mobile,
        className: classnames(!mobile && S.content),
        children: this.renderTab()
      }), /*#__PURE__*/_jsx(Loading, {
        message: this.getLoadingMessage(tabId),
        loading: loading
      })]
    });
  }
}